import React from 'react';
import { useTranslation } from 'react-i18next';

import { PetItem } from './common';

import infoIcon from '../../assets/petDemos/info-icon.svg';

import styles from './CoveragePetsSection.module.css';

const CoveragePetList = ({
  editedItems = [],
  initialItems = [],
  noPendingAction = false,
}) => {
  const { t } = useTranslation('petDemos');
  const items = editedItems.length > 0 ? editedItems : initialItems;

  const petItems = items.map((pet) => ({
    id: pet?.employeeDependentId,
    isIneligible: pet?.demographicData?.isIneligible,
    isRemoved: pet?.demographicData?.isRemoved,
    isRollover: pet?.demographicData?.isRollover,
    label: pet?.demographicData?.petName,
    specie: pet?.demographicData?.species,
  }));

  if (noPendingAction) {
    return (
      <div className={styles.noPendingActionCard}>
        <div className={styles.noPendingActionHeader}>
          <img alt="" src={infoIcon} />

          <span>
            {t('policyInformation.noPetsListed')}
          </span>
        </div>

        <span className={styles.noPendingActionDescription}>
          {t('policyInformation.petListEmpty')}
        </span>
      </div>
    );
  }

  return (
    <div className={styles.policyActionCardPetList}>
      {petItems.map((item) => (
        <PetItem
          key={item.id}
          isRemoved={item.isRemoved || item.isIneligible}
          isRollover={item.isRollover}
          label={item.label}
          specie={item.specie}
        />
      ))}
    </div>
  );
};

export { CoveragePetList };
